const BASE = '/v1/wip';

export default (instance) => ({
  getAll: (params = {}) => instance.get(`${BASE}`, { params }),
  getById: (wipItemId) => instance.get(`${BASE}/${wipItemId}`),
  getTraveler: (wipItemId) => instance.get(`${BASE}/${wipItemId}/traveler`),
  getReservedMaterials: (wipItemId) => instance.get(`${BASE}/${wipItemId}/reserved-materials`),
  getBirthRules: () => instance.get(`${BASE}/birth-rules`),
  getBirthConfig: (lineId) => instance.get(`${BASE}/birth-config/${lineId}`),
  upsertBirthConfig: (lineId, data) => instance.put(`${BASE}/birth-config/${lineId}`, data),
  releaseOrderLine: (lineId) => instance.post(`${BASE}/release/${lineId}`),
  getByOrderLine: (lineId) => instance.get(`${BASE}/by-order-line/${lineId}`),
  getOrderSummary: (orderId) => instance.get(`${BASE}/order-summary/${orderId}`),
  cancel: (wipItemId) => instance.delete(`${BASE}/${wipItemId}`),
  completeFromWarehouse: (wipItemId) => instance.post(`${BASE}/${wipItemId}/complete-from-warehouse`)
});
